
import React, { useState, useEffect } from "react";
import { useMedia } from "./context";
import { MediaItemData } from "./types/mediaTypes";
import EditModeToggle from "./EditModeToggle";
import EditModeOverlay from "./EditModeOverlay";
import MediaItemGrid from "./MediaItemGrid";
import EditMediaSheet from "./EditMediaSheet";

interface MediaControlPanelProps {
  forceEditMode?: boolean;
}

const MediaControlPanel: React.FC<MediaControlPanelProps> = ({ forceEditMode = false }) => {
  const { setIsEditMode } = useMedia();
  const [editingItem, setEditingItem] = useState<MediaItemData | null>(null);
  const [isSheetOpen, setIsSheetOpen] = useState(false);

  // Force edit mode if prop is true
  useEffect(() => {
    if (forceEditMode) {
      setIsEditMode(true);
    }
  }, [forceEditMode, setIsEditMode]);

  const handleEditItem = (item: MediaItemData) => {
    setEditingItem(item);
    setIsSheetOpen(true);
  };

  return (
    <>
      {/* Edit Mode Toggle Button */}
      <EditModeToggle forceEditMode={forceEditMode} />

      {/* Control Overlay when in Edit Mode */}
      <EditModeOverlay forceEditMode={forceEditMode} />

      {/* Edit Buttons on Media Items */}
      <MediaItemGrid onEditItem={handleEditItem} />

      {/* Edit Sheet */}
      <EditMediaSheet 
        isOpen={isSheetOpen}
        onOpenChange={setIsSheetOpen}
        editingItem={editingItem}
      />
    </>
  );
};

export default MediaControlPanel;
